<template>
  <div class="m-content">
    <div class="head-content">
      <div class="center-area">
        <p class="head-title">{{shengyaUser.nickname}}</p>
        <p>{{shengyaUser.studentCollege}}</p>
        <p>{{shengyaUser.studentMajor}}</p>
      </div>
    </div>
    <div class="step-box">
      <FirstStep v-on:listenToChildEvent="getStudentInfo"/>
      <SecondStep v-if="step" :content="studentInfo" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FirstStep from '@/components/FirstStep.vue'
import SecondStep from '@/components/SecondStep.vue'
export default {
  name: 'GetStudentInfo',
  components: {
    FirstStep,
    SecondStep
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  data() {
    return {
      step:false,
      studentInfo:''
    }
  },
  methods:{
    getStudentInfo(info){
      this.step = true
      this.studentInfo = info
    }
  }
}
</script>

<style lang="stylus" scoped>
  .head-content
    overflow:hidden
    margin: 0 0.2rem
    .left-img
      float:left
      width:1.2rem
      height:1.2rem
      border-radius:50%
      margin-top:0.4rem
    .center-area
      float:left
      font-size:0.24rem
      margin-top:0.3rem
      p
        margin:0.1rem
        line-height:0.3rem
      .head-title
        font-size:0.36rem
  .step-box
    background-color:#ffffff
    margin-top:0.3rem
</style>
